import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import API from "../../api/axios"
// import DurationForm from "./DurationForm"
import { useNavigate } from "react-router-dom"
import { FaRegEyeSlash } from "react-icons/fa6"
import ServiceForm from "./ServiceForm"
import { date } from "yup"
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
const ServiceTable = props => {
  const navigate = useNavigate()
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    fetchDurations()
  }, [])

  const handleEditClick = service => {
    console.log("service details", service)
    navigate(`/service-profile/${service.id}`, {
      state: { serviceData: service },
    })
  }

  const fetchDurations = async () => {
    try {
      const authToken = localStorage.getItem("authToken")
      const response = await API.get("/services", {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      })
      // refresh()
      console.log("response value", response)

      setTableData(response.data)
      props.setBreadcrumbItems("Service Table", breadcrumbItems)
    } catch (error) {
      console.error("Error fetching services:", error)
    }
  }

  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Service", link: "#" },
  ]
  const options = {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }
  const tableDataConfig = {
    columns: [
      {
        label: "Name",
        field: "name",
        sort: "asc",
        width: 150,
      },
      {
        label: "Price",
        field: "price",
        sort: "asc",
        width: 150,
      },
      {
        label: "Value (Minutes)",
        field: "duration",
        searchable: true,
        sort: "asc",
        width: 150,
      },
      { label: "Created At", field: "createdAt", sort: "asc", width: 200 },
      { label: "Updated At", field: "updatedAt", sort: "asc", width: 200 },
      { label: "Action", field: "action", sort: "disabled", width: 100 },
    ],

    rows: tableData.map(service => ({
      name: service.name,
      duration: service.duration?.value ?? "N/A",
      price: service.price,
      createdAt: new Date(service.createdAt).toLocaleString("en-IN", options),
      updatedAt: new Date(service.updatedAt).toLocaleString("en-IN", options),
      action: (
        <button
          className="btn btn-success"
          onClick={() => handleEditClick(service)}
        >
          <FaRegEyeSlash size={20} className="text-green-600" />
        </button>
      ),
    })),
  }

  return (
    <Row>
      <Col className="col-12">
        <Card>
          <CardBody>
            <CardTitle className="h4">Service List</CardTitle>
            <ServiceForm refresh={fetchDurations} />
            <MDBDataTable responsive bordered data={tableDataConfig} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default connect(null, { setBreadcrumbItems })(ServiceTable)
